import { Action } from '@ngrx/store';

export enum ActionTypes {
  ShowProgressBar = '[Layout] Show Progress Bar',
  HideProgressBar = '[Layout] Hide Progress Bar',
  BlurMenu = '[Layout] Blur menu',
  UnblurMenu = '[Layout] unblur menu',
}

export class ShowProgressBar implements Action {
  readonly type = ActionTypes.ShowProgressBar;
}

export class HideProgressBar implements Action {
  readonly type = ActionTypes.HideProgressBar;
}

export class BlurMenu implements Action {
  readonly type = ActionTypes.BlurMenu;
}

export class UnblurMenu implements Action {
  readonly type = ActionTypes.UnblurMenu;
}
